import React, { useState, useEffect } from 'react';
import {
  Milk, Database, Home, MapPin, Scale,
  GraduationCap, ShieldAlert, Briefcase, Zap,
  LayoutGrid, ClipboardList, Clock, Radar, FileText, Building2, Users, Wallet,
  Award, ChevronDown, Search, Star, Inbox
} from 'lucide-react';

const MyApps = () => {
  const [portals, setPortals] = useState([]);
  const [loadingApp, setLoadingApp] = useState(null);
  const [collapsed, setCollapsed] = useState({});
  const [search, setSearch] = useState('');
  const [isLoadingList, setIsLoadingList] = useState(true);
  const [favorites, setFavorites] = useState([]);
  const [filter, setFilter] = useState('All'); // 'All' | 'Starred' | 'ADW' | 'TW' | 'TAHDCO'

  useEffect(() => {
    const stored = localStorage.getItem('portals');
    setPortals(stored ? JSON.parse(stored) : []);
    const favStored = localStorage.getItem('portal_favorites');
    setFavorites(favStored ? JSON.parse(favStored) : []);
    setIsLoadingList(false);
  }, []);

  const toggleCategory = (cat) => setCollapsed(prev => ({ ...prev, [cat]: !prev[cat] }));

  const toggleFavorite = (e, appId) => {
    e.stopPropagation();
    setFavorites(prev => {
      const next = prev.includes(appId) ? prev.filter(x => x !== appId) : [...prev, appId];
      localStorage.setItem('portal_favorites', JSON.stringify(next));
      return next;
    });
  };

  // Keyed by exact portal_name from DB — add new portals here as needed
  const portalConfig = {
    'ADW Management System':                       { id: 'adw',           icon: Briefcase,     bgColor: 'bg-white',  iconColor: 'text-slate-600',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: null },
    'Hostel Management Information System (HMIS)': { id: 'hmis',          icon: Home,          bgColor: 'bg-white',  iconColor: 'text-green-600',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: 'https://nallosai.tn.gov.in/adhmAdmin/folders/login/crud.php' },
    'TamilNadu State Scholarship Portal (TNSSP)':  { id: 'tnssp',         icon: GraduationCap, bgColor: 'bg-white', iconColor: 'text-orange-600', borderColor: 'border-gray-200', url: null,                                    ssoCallback: null },
    'Legal Management System (LMS)':               { id: 'lms',           icon: Scale,         bgColor: 'bg-white',   iconColor: 'text-pink-600',   borderColor: 'border-gray-200',   url: 'https://adwlms.com/sso/login',          ssoCallback: null },
    'Prevention of Atrocities (POA)':              { id: 'poa',           icon: ShieldAlert,   bgColor: 'bg-white',    iconColor: 'text-red-600',    borderColor: 'border-gray-200',    url: 'https://tnadwpoa.tn.gov.in/#/landing1', ssoCallback: null },
    'Land Acquisition':                            { id: 'land',          icon: MapPin,        bgColor: 'bg-white', iconColor: 'text-yellow-600', borderColor: 'border-gray-200', url: null,                                    ssoCallback: 'https://laop-adtw.in/sso/callback' },
    'Amudhasurabhi':                               { id: 'amudhasurabhi', icon: Milk,          bgColor: 'bg-white',   iconColor: 'text-blue-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://www.amudhasurabhi.tn.gov.in/auth/sso' },
    'PMO':                                         { id: 'pmo',           icon: Briefcase,     bgColor: 'bg-white',   iconColor: 'text-teal-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://adw.enovasolutions.com/index.php/Login/Adtwsso/callback' },
    'DAP':                                         { id: 'dap',           icon: Database,      bgColor: 'bg-white', iconColor: 'text-purple-600', borderColor: 'border-gray-200', url: 'https://adtwdap.tn.gov.in/#/',          ssoCallback: null },
    'Overseas Scholarship':                        { id: 'overseas',      icon: GraduationCap, bgColor: 'bg-white', iconColor: 'text-indigo-600', borderColor: 'border-gray-200', url: null,                                    ssoCallback: 'https://tnadwscholarship.in/auth/adtw/callback' },
    'Viduthipaarvai':                              { id: 'viduthipaarvai',icon: Zap,           bgColor: 'bg-white',   iconColor: 'text-cyan-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://adtwinspn.tn.gov.in/sso/callback' },
    'PhD Scholarship':                             { id: 'phd',           icon: GraduationCap, bgColor: 'bg-white',iconColor: 'text-fuchsia-600',borderColor: 'border-gray-200',url: null,                                    ssoCallback: 'https://adwphdscholarship.in/api/auth/adtw/callback' },
    'TELP':                                        { id: 'telp',          icon: GraduationCap, bgColor: 'bg-white',iconColor: 'text-emerald-600',borderColor: 'border-gray-200',url: null,                                    ssoCallback: 'https://qatelp.pixous.info/#/auth/callback' },
    'One Portal':                                  { id: 'oneportal',     icon: LayoutGrid,    bgColor: 'bg-white',    iconColor: 'text-sky-600',    borderColor: 'border-gray-200',    url: null,                                    ssoCallback: 'https://testtncwwbv2-qa.pixoustech.app/#/auth/callback' },
    'TOD':                                         { id: 'tod',           icon: ClipboardList, bgColor: 'bg-white',  iconColor: 'text-amber-600',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: 'http://ttm-dev.pixous.info/#/auth/callback' },
    'TIME':                                        { id: 'time',          icon: Clock,         bgColor: 'bg-white',   iconColor: 'text-lime-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://timeqa.pixous.info/#/auth/callback' },
    'Patrol 360':                                  { id: 'patrol360',     icon: Radar,         bgColor: 'bg-white',   iconColor: 'text-rose-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://patrol360-qa.pixoustech.app/#/auth/callback' },
    'TIPS':                                        { id: 'tips',          icon: FileText,      bgColor: 'bg-white', iconColor: 'text-violet-600', borderColor: 'border-gray-200', url: null,                                    ssoCallback: 'https://etender.pixoustech.com/auth/callback' },
    'THMS':                                        { id: 'thms',          icon: Building2,     bgColor: 'bg-white',  iconColor: 'text-zinc-600',   borderColor: 'border-gray-200',   url: null,                                    ssoCallback: 'https://thmsqa.pixoustech.in/App/auth/callback' },
    'TAMS':                                        { id: 'tams',          icon: Users,         bgColor: 'bg-white', iconColor: 'text-stone-600',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: 'https://tamsqa.pixoustech.in/App/auth/callback' },
    'TAHDCO Scheme':                               { id: 'tahdcoscheme',  icon: Wallet,        bgColor: 'bg-white',iconColor:'text-neutral-600',borderColor: 'border-gray-200', url: null,                                    ssoCallback: 'https://scst.pixous.info/auth/callback' },
    'Project Monitoring System':                   { id: 'pms',           icon: ClipboardList, bgColor: 'bg-white',  iconColor: 'text-stone-700',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: 'https://infrapp.tntwd.org.in/tntwd-infra/dsboard_api/' },
    'Fellowship':                                  { id: 'fellowship',    icon: Award,         bgColor: 'bg-white',iconColor: 'text-yellow-600', borderColor: 'border-gray-200', url: null,                                    ssoCallback: 'https://tribalfellowship-api.naduvanapps.com/rest/auth/adtw/callback' },
    'FRA':                                         { id: 'fra',           icon: FileText,      bgColor: 'bg-white', iconColor: 'text-green-600',  borderColor: 'border-gray-200',  url: null,                                    ssoCallback: 'https://fra.ctapps.in/twduat/api/Authentication/adtw/callback' },
    'Puthirai Vannar Welfare Board':                             { id: 'puthiraivannar',icon: ShieldAlert,   bgColor: 'bg-white',   iconColor: 'text-red-600',    borderColor: 'border-gray-200',    url: null,                                    ssoCallback: 'https://pvb.macss.in/SSO' },
    'Tholkudi':                                    { id: 'tholkudi',      icon: Award,         bgColor: 'bg-white',   iconColor: 'text-purple-600', borderColor: 'border-gray-200',    url: 'https://tholkudi.in/home',              ssoCallback: null },
    'Narikuravar & Palangudinar - Membership Card & Welfare Schemes': { id: 'narikuravar', icon: ShieldAlert, bgColor: 'bg-white', iconColor: 'text-teal-600', borderColor: 'border-gray-200', url: 'https://tntwd.org.in/mic/admin/login',  ssoCallback: null },
  };

  // Department(s) per portal — array so a portal can belong to multiple depts
  const portalDept = {
    'ADW Management System':                       ['ADW'],
    'Hostel Management Information System (HMIS)': ['ADW', 'TW'],
    'TamilNadu State Scholarship Portal (TNSSP)':  ['ADW'],
    'Legal Management System (LMS)':               ['ADW'],
    'Prevention of Atrocities (POA)':              ['ADW'],
    'Land Acquisition':                            ['ADW'],
    'Amudhasurabhi':                               ['ADW', 'TW'],
    'PMO':                                         ['ADW'],
    'DAP':                                         ['ADW'],
    'Overseas Scholarship':                        ['ADW'],
    'Viduthipaarvai':                              ['ADW', 'TW'],
    'PhD Scholarship':                             ['ADW'],
    'Puthirai Vannar Welfare Board':                             ['ADW'],
    'TELP':                                        ['TAHDCO'],
    'One Portal':                                  ['TAHDCO'],
    'TOD':                                         ['TAHDCO'],
    'TIME':                                        ['TAHDCO'],
    'Patrol 360':                                  ['TAHDCO'],
    'TIPS':                                        ['TAHDCO'],
    'THMS':                                        ['TAHDCO'],
    'TAMS':                                        ['TAHDCO'],
    'TAHDCO Scheme':                               ['TAHDCO'],
    'Fellowship':                                  ['TW'],
    'Project Monitoring System':                   ['TW'],
    'FRA':                                         ['TW'],
    'Tholkudi':                                    ['TW'],
    'Narikuravar & Palangudinar - Membership Card & Welfare Schemes': ['TW'],
  };

  const deptChipStyle = {
    'ADW':    'bg-blue-100 text-blue-600 border-blue-400',
    'TW':     'bg-emerald-100 text-emerald-600 border-emerald-400',
    'TAHDCO': 'bg-orange-100 text-orange-600 border-orange-400',
  };

  // Portal abbreviations (short codes shown as a badge on each card) — per official portal list
  const portalAbbrev = {
    'ADW Management System':                       'ADW',
    'Hostel Management Information System (HMIS)': 'HMIS',
    'TamilNadu State Scholarship Portal (TNSSP)':  'TNSSP',
    'Legal Management System (LMS)':               'LMS',
    'Prevention of Atrocities (POA)':              null,
    'Land Acquisition':                            'Land',
    'Amudhasurabhi':                               null,
    'PMO':                                         'PMO',
    'DAP':                                         'DAP',
    'Overseas Scholarship':                        null,
    'Viduthipaarvai':                              null,
    'PhD Scholarship':                             null,
    'TELP':                                        'TELP',
    'Fellowship':                                  null,
    'Project Monitoring System':                   'Project Monitoring System',
    'FRA':                                         null,
    'Puthirai Vannar Welfare Board':                             null,
    'One Portal':                                  'ONE PORTAL',
    'TOD':                                         'TOD',
    'TIME':                                        'TIME',
    'Patrol 360':                                  'PATROL 360',
    'TIPS':                                        'TIPS',
    'THMS':                                        'THMS',
    'TAMS':                                        'TAMS',
    'TAHDCO Scheme':                               'TAHDCO Schemes',
    'Tholkudi':                                    'THOLKUDI',
    'Narikuravar & Palangudinar - Membership Card & Welfare Schemes': 'NPMCWS',
  };

  // Full "Portal Name" from the official portal list (shown as card title)
  const portalDisplayName = {
    'ADW Management System':                       'ADW Management System',
    'Hostel Management Information System (HMIS)': 'Hostel Management Information System',
    'TamilNadu State Scholarship Portal (TNSSP)':  'TN State Scholarship Portal',
    'Legal Management System (LMS)':               'Legal Management System',
    'Prevention of Atrocities (POA)':              'Prevention of Atrocities',
    'Land Acquisition':                            'Land Management',
    'Amudhasurabhi':                               'Amudhasurabhi (Food Monitoring Application)',
    'PMO':                                         'ADW Infrastructure Monitoring',
    'DAP':                                         'Development Action Plan',
    'Overseas Scholarship':                        'Overseas Scholarship',
    'Viduthipaarvai':                              'Viduthiparvai (Inspection)',
    'PhD Scholarship':                             'PHD Scholarship',
    'TELP':                                        'Education Loan Portal',
    'Fellowship':                                  'Tribal Fellowship',
    'Project Monitoring System':                   'Tribal Infrastructure Monitoring',
    'FRA':                                         'Forest Rights Act Phase- 1 & 2',
    'Puthirai Vannar Welfare Board':                             'Puthirai Vannar Welfare Board',
    'One Portal':                                  'Cleanliness Workers Welfare Board',
    'TOD':                                         'Online Diary Portal',
    'TIME':                                        'Construction Progress Monitoring System 2.0',
    'Patrol 360':                                  'Construction Multi-Monitoring System',
    'TIPS':                                        'Tender Integrated Processing System',
    'THMS':                                        'TAHDCO Housing Management System',
    'TAMS':                                        'Student Training Attendance Application',
    'TAHDCO Scheme':                               'Scheme Application Portal',
  };

  // Category assignment per portal — per official portal list "Categories" column
  const portalCategory = {
    'ADW Management System':                       'Administration',
    'Prevention of Atrocities (POA)':              'Rights/Act',
    'Legal Management System (LMS)':               'Administration',
    'Land Acquisition':                            'Infrastructure',
    'DAP':                                         'Rights/Act',
    'Hostel Management Information System (HMIS)': 'Education',
    'Viduthipaarvai':                              'Education',
    'PhD Scholarship':                             'Education',
    'Overseas Scholarship':                        'Education',
    'PMO':                                         'Infrastructure',
    'Puthirai Vannar Welfare Board':                             'Other Agencies',
    'Amudhasurabhi':                               'Education',
    'TamilNadu State Scholarship Portal (TNSSP)':  'Education',
    'Project Monitoring System':                   'Infrastructure',
    'FRA':                                         'Rights/Act',
    'Fellowship':                                  'Education',
    'TAHDCO Scheme':                               'Livelihood',
    'TIPS':                                        'Administration',
    'TIME':                                        'Infrastructure',
    'THMS':                                        'Infrastructure',
    'TELP':                                        'Livelihood',
    'TOD':                                         'Administration',
    'TAMS':                                        'Livelihood',
    'Patrol 360':                                  'Infrastructure',
    'One Portal':                                  'Other Agencies',
    'Tholkudi':                                    'Art and Culture',
    'Narikuravar & Palangudinar - Membership Card & Welfare Schemes': 'Other Agencies',
  };

  const buildApp = (portalName) => ({
    ...(portalConfig[portalName] || { id: portalName, icon: Scale, bgColor: 'bg-white', iconColor: 'text-gray-600', borderColor: 'border-gray-200', url: null, ssoCallback: null }),
    name: portalDisplayName[portalName] || portalName,
    abbrev: portalAbbrev[portalName] || null,
    depts: portalDept[portalName] || [],
    category: portalCategory[portalName] || 'Other',
  });

  const apps = portals.map(p => buildApp(p.portal_name));

  const CATEGORY_ORDER = ['Rights/Act', 'Administration', 'Infrastructure', 'Education', 'Livelihood', 'Other Agencies', 'Art and Culture', 'Other'];

  const searchLower = search.trim().toLowerCase();
  const matchesSearch = (a) =>
    !searchLower ||
    a.name.toLowerCase().includes(searchLower) ||
    (a.abbrev && a.abbrev.toLowerCase().includes(searchLower)) ||
    a.category.toLowerCase().includes(searchLower);

  const matchesFilter = (a) => {
    if (filter === 'All') return true;
    if (filter === 'Starred') return favorites.includes(a.id);
    return (a.depts || []).includes(filter);
  };

  const filteredApps = apps.filter(a => matchesSearch(a) && matchesFilter(a));
  const favoriteApps = filteredApps.filter(a => favorites.includes(a.id));
  const groupedApps = CATEGORY_ORDER
    .map(cat => ({ category: cat, items: filteredApps.filter(a => a.category === cat) }))
    .filter(g => g.items.length > 0);

  const handleAppClick = (app) => {
    console.log('Clicked app:', app);
    if (app.ssoCallback) {
      setLoadingApp(app.id);
      const token = localStorage.getItem('token');
      const userStr = localStorage.getItem('user');
      const parsedUser = userStr ? JSON.parse(userStr) : {};
      const email = parsedUser.email || '';
      setTimeout(() => {
        window.location.href = `${app.ssoCallback}?token=${token}&username=${email}`;
      }, 1000);
      return;
    }
    if (!app.url) return;
    setLoadingApp(app.id);
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');
    const parsedUser = userStr ? JSON.parse(userStr) : {};
    const email = parsedUser.email || '';
    setTimeout(() => {
      window.open(`${app.url}?token=${token}&username=${email}`, '_blank');
      setLoadingApp(null);
    }, 1000);
  };

  // Category → uniform splash strip color (top border) across all cards in that group
  const categorySplash = {
    'Rights/Act':      'bg-red-500',
    'Administration':  'bg-amber-500',
    'Infrastructure':  'bg-emerald-500',
    'Education':       'bg-blue-500',
    'Livelihood':      'bg-purple-500',
    'Other Agencies':  'bg-teal-500',
    'Art and Culture': 'bg-pink-500',
    'Other':           'bg-gray-500',
  };

  const renderCard = (app, inFavorites = false) => {
    const Icon = app.icon;
    const isLoading = loadingApp === app.id;
    const isClickable = app.url || app.ssoCallback;
    const isFav = favorites.includes(app.id);
    const depts = app.depts || [];
    // For multi-dept portals, use the first dept's chip color and show a combined label
    const primaryDept = depts[0] || null;
    const deptLabel = depts.length > 1 ? depts.join('+') : primaryDept;
    const deptCls = deptChipStyle[primaryDept] || 'bg-gray-100 text-gray-700 border-gray-400';

    // Icon tile keeps portal's own hue; splash strip uses the CATEGORY color for uniformity
    const hueMatch = app.iconColor && app.iconColor.match(/text-([a-z]+)-/);
    const hue = hueMatch ? hueMatch[1] : 'gray';
    const iconTileBg = `bg-${hue}-50`;
    const splashBg = categorySplash[app.category] || categorySplash['Other'];

    const cardBg = 'bg-white';
    const cardBorder = 'border-gray-200';
    return (
      <div
        key={app.id}
        onClick={() => handleAppClick(app)}
        className={`${cardBg} border ${cardBorder} p-3 pt-4 min-h-[84px] flex flex-col hover:shadow-md hover:border-gray-300 hover:-translate-y-0.5 transition-all duration-200 group relative overflow-hidden ${isClickable ? 'cursor-pointer' : 'cursor-default'} ${isLoading ? 'opacity-70' : ''}`}
      >
        <span className={`absolute top-0 left-0 right-0 h-1 ${splashBg}`}></span>
        <div className="absolute top-1.5 right-1.5 flex items-center gap-1">
          <button
            onClick={(e) => toggleFavorite(e, app.id)}
            title={isFav ? 'Remove from favorites' : 'Add to favorites'}
            className={`p-0.5 transition-colors ${isFav ? 'text-yellow-500 hover:text-yellow-600' : 'text-gray-300 hover:text-yellow-500'}`}
          >
            <Star className={`w-3 h-3 ${isFav ? 'fill-current' : ''}`} />
          </button>
          {deptLabel && (
            <span className={`text-[8px] font-bold tracking-wider px-1 py-0.5 border ${deptCls}`}>
              {deptLabel}
            </span>
          )}
        </div>
        <div className={`w-8 h-8 ${iconTileBg} flex items-center justify-center mb-2 group-hover:scale-110 transition-transform`}>
          <Icon className={`w-4 h-4 ${app.iconColor}`} />
        </div>
        <h3 className="text-xs font-semibold text-gray-800 pr-10 leading-tight">{app.name}</h3>
      </div>
    );
  };

  const renderSkeleton = () => (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="border border-gray-400 bg-gray-200 p-6 min-h-[160px] animate-pulse">
          <div className="w-12 h-12 bg-gray-200 mb-4" />
          <div className="h-4 bg-gray-200 w-3/4 mb-2" />
          <div className="h-3 bg-gray-200 w-1/2" />
        </div>
      ))}
    </div>
  );

  return (
    <div className="space-y-6">
      {loadingApp && (
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4">
            <div className="w-10 h-10 border-4 border-[#3d82c4] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-gray-700 font-medium text-sm">Redirecting to portal...</p>
          </div>
        </div>
      )}

      {/* Header + filter pills + search */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {apps.length > 0 && (
          <>
            <div className="flex items-center gap-1.5 flex-wrap">
              {['All', 'Starred', 'ADW', 'TW', 'TAHDCO'].map(f => {
                const active = filter === f;
                return (
                  <button
                    key={f}
                    onClick={() => setFilter(f)}
                    className={`px-3 py-1.5 text-xs font-semibold border transition-colors ${
                      active
                        ? 'bg-gray-900 text-white border-gray-900'
                        : 'bg-white text-gray-700 border-gray-200 hover:bg-gray-50'
                    }`}
                  >
                    {f === 'Starred' ? '★ Starred' : f}
                  </button>
                );
              })}
            </div>
            <div className="relative w-full lg:w-80">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search portals..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-9 pr-4 py-2.5 border border-gray-200 focus:outline-none focus:border-[#3d82c4] text-sm bg-white"
              />
            </div>
          </>
        )}
      </div>

      {isLoadingList ? (
        renderSkeleton()
      ) : apps.length === 0 ? (
        <div className="text-center py-20">
          <Inbox className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-700 mb-2">No portals available yet</h3>
          <p className="text-sm text-gray-500 max-w-md mx-auto">
            You don't have access to any portals yet. Please contact your administrator to get access.
          </p>
        </div>
      ) : filteredApps.length === 0 ? (
        <div className="text-center py-16">
          <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-sm text-gray-500">No portals match "{search}"</p>
          <button
            onClick={() => setSearch('')}
            className="mt-3 text-xs text-[#3d82c4] hover:underline"
          >
            Clear search
          </button>
        </div>
      ) : (
        <div className="space-y-10">
          {/* Categorized rows */}
          {groupedApps.map(({ category, items }) => {
            const isCollapsed = !!collapsed[category];
            return (
              <div key={category}>
                <button
                  onClick={() => toggleCategory(category)}
                  className="w-full flex items-center justify-between text-left mb-4 group"
                >
                  <div className="flex items-center gap-3">
                    <h2 className="text-lg font-bold text-gray-600 uppercase tracking-wide">
                      {category}
                    </h2>
                    <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5">
                      {items.length} {items.length === 1 ? 'portal' : 'portals'}
                    </span>
                  </div>
                  <ChevronDown
                    className={`w-5 h-5 text-gray-500 transition-transform ${isCollapsed ? '-rotate-90' : ''}`}
                  />
                </button>
                {!isCollapsed && (
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3">
                    {items.map(app => renderCard(app))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MyApps;